import React, { Component } from 'react';
import './news.css';
import { getNews, paginator } from '../Utilities/newsUtil';
import { Helmet } from 'react-helmet-async';
import ReactHtmlParser from 'react-html-parser';
import Pagination from '../Common/Pagination';
import news from './news.json';
import ModalImage from 'react-modal-image';

class News extends Component {
    state = {
        data: [],
        currentPage: 1,
        sizePerPage: 7,
        currentNews: {}
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        //copy news from json file
        const data = news.news;
        const selectionByParam = this.onLoadGetParameterId(data);
        //set data to state data
        this.setState({ data });
        this.setState({ currentNews: (selectionByParam ? selectionByParam[0] : data[0]) });
    }

    onLoadGetParameterId(data) {
        if (this.props.match.params.id) {
            const selectedNews = data.filter(d => {
                return d.id === this.props.match.params.id;
            });
            return selectedNews;
        }
        return null;

    }

    onClickNewsDisplay = (newsId) => {
        const selectedNews = getNews(news.news, newsId);
        this.setState({ currentNews: selectedNews });
    }

    changeCurrentPageHandler = (pageNumber) => {
        this.setState({ currentPage: pageNumber });
    }

    render() {
        const { data, currentPage, sizePerPage, currentNews } = this.state;
        const paginatedNews = paginator(data, sizePerPage, currentPage);
        return (
            <React.Fragment>
                <Helmet>
                    <title>ニュース | 日本アドバンストリーダーズソフトウェア株式会社</title>
                </Helmet>
                <div id='news-container'>
                    <div className='container-box banner-container' id='news-banner-container'>
                        <div className='overlay'></div>
                        <div className='row'>
                            <div className='col'>
                                <h1>ニュース</h1>
                                <h3>NEWS</h3>
                            </div>
                        </div>
                    </div>
                    <div className="container-box row row-title mb-1">
                        <div className="col col-hr"><hr /></div>
                        <div className="col-12 col-md-6">
                            <h1 className="text-orange">ニュース一覧</h1>
                            <h5>NEWS LIST</h5>
                        </div>
                        <div className="col col-hr"><hr /></div>
                    </div>
                    <div className='container-fluid' id='news-content-container'>
                        <div className="row">
                            <div className="col-md-4 col-sm-12 mt-lg-5">
                                <ul id='news-list'>
                                    {paginatedNews.map(news => {
                                        return (
                                            <li className={currentNews.id === news.id ? "selected_news" : ""} key={news.id} onClick={() => this.onClickNewsDisplay(news.id)}>
                                                <span className="news-date">{news.date}</span><br />
                                                <span className="news-title">{news.title}</span>
                                            </li>
                                        )
                                    })}
                                </ul>
                                <div className="pt-3">
                                    <Pagination size={data.length}
                                        pageSize={sizePerPage}
                                        currentPage={currentPage}
                                        pageChangeHandler={this.changeCurrentPageHandler} />
                                </div>
                            </div>
                            <div className="col-md-8 col-sm-12 pb-5 px-sm-3 p-lg-5">
                                <div id="news-post-container">
                                    <h2>{currentNews.title}</h2>
                                    <small>{currentNews.date}</small>

                                    <hr />
                                    <div>
                                        {currentNews.contentBeforeImage ? ReactHtmlParser(currentNews.contentBeforeImage) : ""}
                                    </div>
                                    {/* {currentNews.fileName ? (<img className="img-fluid" src={require('../../assets/images/news/news-post/' + currentNews.fileName).default} alt={currentNews.title} />) : ""} */}
                                    {currentNews.fileName ? (<ModalImage small={require('../../assets/images/news/news-post/' + currentNews.fileName).default}
                                        large={require('../../assets/images/news/news-post/' + currentNews.fileName).default} hideDownload={true}
                                        alt={currentNews.title} className="img-fluid" />) : null}
                                    <div>
                                        {currentNews.contentAfterImage ? ReactHtmlParser(currentNews.contentAfterImage) : ""}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </React.Fragment>
        )
    }
}

export default News;